import * as React from "react";
import Typography from "@mui/material/Typography";
import { useTheme } from "@mui/material/styles";
import { useMediaQuery } from "@mui/material";
import FormDialog from "../../../../components/Dialog/FormDialog";
import { useResponsive } from "../../../../hooks/useResponsive";
import { useBoardDocumentState } from "./hooks/useBoardDocumentState";
import BoardDocumentEditor from "./BoardDocumentEditor";
import { useBoardDocumentEditor } from "./hooks/useBoardDocumentEditor";

export default React.memo(function BoardDocument({
    boardName,
    setShowSummary,
    showSummary,
    boardId,
    isPermission,
}) {
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
    const isMobile = useResponsive("down", "md");
    const { summary, setSummary, isLoadingDocument, isPending, handleClose } =
        useBoardDocumentState({
            boardId,
            showSummary,
            setShowSummary,
            isPermission,
        });
    const { modules, formats, handleChange } = useBoardDocumentEditor({
        isPermission,
        setSummary,
    });

    return (
        <FormDialog
            open={showSummary}
            fullScreen={fullScreen}
            title={boardName}
            handleClose={handleClose}
            fullWidth={false}
            sx={{
                zIndex: 1200,
                "& .MuiDialog-container": {
                    "& .MuiPaper-root": {
                        width: "100%",
                        height: isMobile ? "100vh" : "calc(100vh - 30px)",
                        borderRadius: isMobile ? "" : "12px",
                        margin: isMobile ? "auto" : "15px auto",
                        maxWidth: "1180px",
                    },
                },
            }}
        >
            <Typography>
                <p className="summary-discription-title">
                    A shared space for important info — links, notes, and images, all saved automatically.
                </p>
                <BoardDocumentEditor
                    summary={summary}
                    modules={modules}
                    formats={formats}
                    onChange={handleChange}
                    isPermission={isPermission}
                    isMobile={isMobile}
                    isLoadingDocument={isLoadingDocument}
                    isPending={isPending}
                />
            </Typography>
        </FormDialog>
    );

});
